import { createContext, useContext, useEffect, useState } from "react";
import { projectType } from "../services/project-type";
import jwt from "../services/jwt";

const ProjectTypeContext = createContext();

export const ProjectTypeProvider = ({ children }) => {
    const [projectTypeValue, setProjectTypeValue] = useState(null);

    const updateProjectType = (newValue) => {
        setProjectTypeValue(newValue);
    };

    useEffect(() => {
        if (jwt.getToken())
            projectType.getProjectType().then((res) => {
                setProjectTypeValue(res);
            });
    }, []);

    return (
        <ProjectTypeContext.Provider
            value={{ projectTypeValue, updateProjectType }}>
            {children}
        </ProjectTypeContext.Provider>
    );
};

export const useProjectTypeContext = () => useContext(ProjectTypeContext);
